const isDevMode = process.env.NODE_ENV === 'development'
import store from '@/store'
let existingErrors = {}
let suppressedCount = {}


function flushSuppressed() {
	if (Object.keys(suppressedCount).length === 0) return
	const payload = {
		user_id: store.state.user_info?.user_id || -1,
		page: window.location.href,
		suppressed_errors: JSON.stringify(suppressedCount),
		method: 'PATCH'
	}
	U.ajax('log_any_errors', payload, result=>{
		if (result.status != 'ok') {
			console.error('Error storing log', result)
			return
		}
		suppressedCount = {}
	})
}

setInterval(() => {
	flushSuppressed()
}, 30000)

function normalizeStack(stack, maxFrames = 30, maxChars = 8000) {
	if (!stack) return ""
	const lines = String(stack).split("\n")

	// first line + first N frames
	const [header, ...frames] = lines
	const kept = [header, ...frames.slice(0, maxFrames)]
	let out = kept.join("\n")

	// also trim by max length to be safe
	if (out.length > maxChars) {
		out = out.slice(0, maxChars) + "...<truncated>"
	}
	return out
}


function shouldSend(message) {
	// dont log google errors
	if (message.toLowerCase().includes('google')) {
		return false
	}
	const dedupeWindow = 300 // seconds
	const nowInISO = new Date().toISOString()
	const nowInSeconds = Math.floor(new Date(nowInISO)/1000)
	const lastInISO = existingErrors[message] || null
	const lastInSeconds = Math.floor(new Date(existingErrors[message])/1000) || 0
	const suppressedCountKey = `${store.state.user_info?.user_id || -1}||${window.location.href}||${message}||${lastInISO}`
	if (nowInSeconds - lastInSeconds < dedupeWindow) {
		suppressedCount[suppressedCountKey] = (suppressedCount[suppressedCountKey] || 0) + 1
		return false
	}
	existingErrors[message] = nowInISO
	return true
}

// Helper function to create error payload
function createErrorPayload(errorData) {
	return {
		user_id: store.state.user_info?.user_id || -1,
		message: errorData.error.message,
		instance: window.location.origin,
		page: window.location.href,
		user_agent: navigator.userAgent,
		...errorData
	}
}

// Helper function to safely log errors to server
function logToServer(errorPayload) {
	const should_send = shouldSend(errorPayload.error.message)
	if (should_send) {
		// console.log('send')
		const safe_payload = {
			method: 'POST',
			timestamp: existingErrors[errorPayload.error.message],
			...errorPayload,
			error: JSON.stringify(errorPayload.error ?? {})
		}
		U.ajax('log_any_errors', safe_payload, result=>{
			if (result.status != 'ok') {
				console.error('Error storing log', result)
				return
			}
		})
		flushSuppressed()
	}
	// else {
	//     console.log('dont send')
	// }
}

function vueErrorLogger(err, vm, info) {
	console.error('Vue Error:\n', err)

	// Mark immediately to prevent double-handling
	if (err) {
		err._vueHandled = true
	}

	// If in development mode, return instead of sending to server
	if (isDevMode) {
		return
	}

	const errorPayload = createErrorPayload({
		error: {
			message: err?.message || 'Unknown Vue error',
			stack: normalizeStack(err?.stack) || null,
			info,
			component: vm?.$options?.name || 'anonymous',
			// propsData: vm?.$options?.propsData
		},
		error_type: 'vue_error_handler'
	})

	logToServer(errorPayload)
};

function windowErrorLogger(message, source, lineno, colno, error) {
	// Skip if Vue already handled this error
	if (error?._vueHandled) {
		return
	}

	console.error('Global Error:\n', error || message)

	// If in development mode, return instead of sending to server
	if (isDevMode) {
		return
	}

	const errorPayload = createErrorPayload({
		error: {
			message: error?.message || message || 'Unknown global error',
			stack: normalizeStack(error?.stack) || null,
			source,
			lineno,
			colno
		},
		error_type: 'window_onerror'
	})

	logToServer(errorPayload)
};

// Also handle unhandled promise rejections
function unhandledPromiseRejectionHandler(event) {
	// We do not need to log this error as the default handler will catch it, and
	// there is no way to prevent the browser from logging it.

	// If in development mode, return instead of sending to server
	if (isDevMode) {
		return
	}

	const error = event.reason
	const syntheticStack = new Error().stack;
	const errorPayload = createErrorPayload(store, {
		error: {
			message: error?.message || 'Unhandled Promise Rejection',
			stack: error?.stack || syntheticStack,
			reason: typeof error === 'string' ? error : JSON.stringify(error)
		},
		error_type: 'unhandled_promise_rejection'
	})

	logToServer(errorPayload)
};

export function initializeErrorLogging(vueInstance) {
	try {
		// Vue error handler
		vueInstance.config.errorHandler = (err, vm, info) => vueErrorLogger(err, vm, info)
    
		// Global window error handler
		window.onerror = (message, source, lineno, colno, error) => windowErrorLogger(message, source, lineno, colno, error)
    
		// Unhandled promise rejections
		window.addEventListener('unhandledrejection', event => unhandledPromiseRejectionHandler(event))
    
		console.log(`Error logging initialized ${isDevMode ? '(development mode)' : '(production mode)'}`)
	} catch (initError) {
		console.error('Failed to initialize error logging:', initError)
		return
	}
}